import React from 'react';
import { useOpenWorkspace } from '../../hooks/useOpenWorkspace';
import type { ConnectorRow } from '../../types/aai';

/*
 * Code hosts (GitHub, GitLab) are connected once for the whole company in the
 * Workspace, under Settings → Code & ownership. This row says what the
 * Workspace holds and opens that screen; it never offers a second Connect.
 */
const ownsCompany = (): boolean => {
  const role = localStorage.getItem('aai_workspace_role');
  return !role || role === 'OWNER';
};

export const workspaceGitLine = (row: ConnectorRow): string => {
  const git = row.workspace_git;
  if (!git || !git.known) return 'Managed in your Workspace.';
  if (git.connected && git.account) return `Connected in your Workspace as ${git.account}.`;
  if (git.connected) return 'Connected in your Workspace.';
  if (!ownsCompany()) return 'Not connected yet.';
  return 'Not connected yet. Connect it in your Workspace.';
};

export const ManageInWorkspace: React.FC<{ row: ConnectorRow; size?: 'sm' | 'xs'; className?: string; label?: string }> = ({ row, size = 'sm', className = '', label }) => {
  const { opening, open } = useOpenWorkspace();
  const clientId = localStorage.getItem('client_id');
  const go = () => open(clientId, `/customer/workspace?workspaceId=${encodeURIComponent(clientId || '')}&settings=code`);
  let text = 'text-[12px] px-3 py-1.5';
  if (size === 'xs') text = 'text-[11px] px-2.5 py-1';
  const actionLabel = label || (row.workspace_git?.connected ? `View ${row.label} access` : `Connect ${row.label}`);
  if (!ownsCompany()) return null;
  return (
    <button
      type="button"
      onClick={go}
      disabled={opening || !clientId}
      className={`inline-flex items-center rounded-full border border-line bg-white font-semibold text-ink transition-colors hover:border-ink disabled:opacity-50 ${text} ${className}`}
    >
      {actionLabel}
    </button>
  );
};

export default ManageInWorkspace;
